<template>
  <div>
    <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
      <md-card >
        <md-card-header class="hide-mobile" data-background-color="newyellow">
          <div style="display: flex;align-items: center;">
            <md-icon class="configicon">money</md-icon>
            <h4 class="tittle">Boletos</h4>
          </div>
        </md-card-header>
        <md-card-content>        
          <ListaMesesBoleto />          
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>
<script>
import ListaMesesBoleto from "../components/Boletos/ListaMesesBoleto";
export default {
  components: {
    ListaMesesBoleto,
  },
  data() {
    return {
      icons: true,
      centered: false,
      grow: false,
      vertical: true
    };
  }, created(){

  }
};
</script>
<style scoped>
.configicon {
  width: 20px;
  margin: 3px;
  margin-right: 19px;
  color: #fff !important;
  font-size: 36px !important;
}
</style>
